<template>
  <div id="MyPresent">
    <div class="table">
      <div
        class="table-card"
        v-for="(item, index) in giftList"
        :key="index"
        style="overflow: hidden"
        :class="item.showState === '已失效' ? 'table-diabled' : ''"
      >
        <div class="table-card-header">
          <div>
            <div class="table-card-header-name">
              {{ item.commodityName
              }}<i class="order-type">
                {{ item.showType }}
              </i>
            </div>
            <div v-if="item.activeType === 'TYING' && item.mainShowId">
              <span>{{ $t('搭售-主订单号：') }}{{ item.mainShowId }}</span>
            </div>
            <div style="margin-left: 20px" v-show="item.saleType == 2">
              {{ $t('子产品价格:')
              }}<es-popover placement="right" width="450" trigger="click">
                <div>
                  <es-row class="detailTip" v-for="(pro, index) in item.subProductInfo" :key="index">
                    <es-col :span="15" class="left">{{ pro.productName }}</es-col>
                    <es-col :span="9"> {{ pro.price }}{{ item.units == $t('份/年') ? $t('元/份/年') : $t('元/份') }} </es-col>
                  </es-row>
                </div>
                <i class="es-icon-question" v-show="item.saleType == 2" slot="reference" @click="getDetail(item)"></i>
              </es-popover>
            </div>
          </div>
          <div>
            <div class="table-card-header-name">{{ $t('订单编号：') }}{{ item.showId }}</div>
            <div v-show="item.relOrderId" class="tip time">{{ $t('延时订单：') }}{{ item.oshowId }}</div>
            <div v-if="item.activeType === 'TYING' && item.mainCommodityName">
              <span>{{ $t('搭售-主商品：') }}{{ item.mainCommodityName }}</span>
            </div>
          </div>
          <div>
            <div class="table-card-header-name" style="margin-left: 20px">{{ $t('下单时间：') }}{{ item.createTime | formatUtc }}</div>
            <div v-show="item.showRemark" style="margin-left: 20px">({{ item.showRemark }})</div>
          </div>
          <div>
            <div
              style="font-weight: normal"
              :class="{
                /* i18n-ignore */
                ready: item.showState == '待生效',
                unsuccess: item.showState == '已失效',
                success: item.showState == '生效中' || item.showState == '交易成功',
                stop: item.showState == '已停用',
              }"
            >
              <!-- i18n-ignore -->
              <i class="es-icon-circle-check" v-if="item.showState != '待生效' && item.showState != '已停用'"></i>
              <!-- i18n-ignore -->
              <i class="icon-stop" v-else-if="item.showState == '已停用'"></i>
              <!-- i18n-ignore -->
              <i class="readyIcon" v-if="item.showState == '待生效'"></i>
              {{ item.showState }}
            </div>
          </div>
        </div>
        <div class="table">
          <es-row class="table-title">
            <es-col :span="4">{{ $t('订单数量') }}</es-col>
            <es-col :span="5">{{ $t('有效时间') }}</es-col>
            <es-col :span="item.lockNum > 0 ? 3 : 5">{{ $t('已使用量') }}</es-col>
            <es-col :span="2" v-if="item.lockNum > 0">{{ $t('预扣用量') }}</es-col>

            <es-col :span="3">{{ $t('当前余量') }}</es-col>
            <es-col :span="3">{{ $t('订单状态') }}</es-col>
            <es-col :span="4">{{ $t('操作') }}</es-col>
          </es-row>
          <es-row class="table-main">
            <es-col :span="4"> {{ item.showSendNumber }}&nbsp; </es-col>
            <es-col :span="5"> {{ item.startToEnd }}&nbsp; </es-col>
            <es-col :span="item.lockNum > 0 ? 3 : 5"> {{ item.showUserd && item.productType != 2 ? item.showUserd : '--' }} &nbsp; </es-col>
            <es-col :span="2" v-if="item.lockNum > 0">
              {{
                !item.lockNum
                  ? '--'
                  : item.units === 'G'
                  ? showDataUnit(item.lockNum, 'floor', item)
                  : getShowPrice(item, 'lockNum', 'MB') + getShowUnit(item, 'MB')
              }}
            </es-col>
            <es-col :span="3"> {{ item.showSendMargin && item.productType != 2 ? item.showSendMargin : '--' }}&nbsp; </es-col>
            <es-col :span="3"> {{ item.showState }}&nbsp; </es-col>
            <es-col :span="4">
              <es-button type="text" @click="downLoad(item)" class="operation wd-80" v-if="item.webParameter.showLicenseDownload">{{
                $t('下载License')
              }}</es-button>
              <es-popover
                v-if="item.webParameter.showLicenseDownload"
                placement="bottom"
                width="200"
                trigger="hover"
                :content="$t(`下载license授权文件后请在指定的系统中导入使用`)"
              >
                <i class="es-icon-question" slot="reference" style="margin-right: 5px"></i>
              </es-popover>
              <es-button
                type="text"
                @click="jumpDetail(item)"
                :disabled="item.webParameter.showGiftBillDetail === 2"
                v-show="item.webParameter.showGiftBillDetail !== 0"
                >{{ $t('查看账单') }}</es-button
              >
              &nbsp;
              <es-button
                v-if="item.webParameter.isShowAuth === 1 && item.activeType === 'TYING' && item.mainShowId"
                type="text"
                @click="empower(item, 'MyOrder', '', 1)"
                >{{ $t('授权') }}</es-button
              >
              &nbsp;
              <es-button type="text" v-if="item.webParameter.isAuthOrder === 1" @click="jumpDetail(item, $t('授权记录'))">
                {{ $t('授权记录') }}</es-button
              >
            </es-col>
          </es-row>
        </div>
      </div>
      <es-row class="noData" v-show="giftList.length === 0" style="height: 200px">
        <es-empty
          style="margin: 25px; color: #999; line-height: 40px"
          :description="$t(`暂无更多数据`)"
          image="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAA/CAYAAABQHc7KAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAA4XSURBVHgB7VtdkhxHEc6s7vlb7dqSZTlwEGDsCOMHeNCDD+Aj+AaYG8AJZE4AnABuwBXgAAQmghfzggWBDfphJe3uzOxOdyWZlZlV1btju1ux6yeVYjQ91dXVlf9fZtUiTGiPH5981LTtAyL6KHciEBChXvMXWZ804iuE3McNUR9INzD1pRF8jel+PS//+Gvs42/ffPPw93BDDccOfPLk7GMM+AdQshJRTEgmqEyI5Bcyiv9jygAyI/Qe+ZBEdM2w9KUXy+Uctuc7Gfnp3TurX8ENtDB2IDbwwC9lfYl4VKqE6MASzDSnL+EQKfHKLXvS6JM5KGKeE8qVaAP/R4t5C/Lhhx8cH28ewA200Qxguu4nSSMUiZschRmkTJHVm7wxq0URvEqcgGwONM5koSebSFph5rBczJgJM+wpfnoTTBjPAFT1JnINz/0mcp4MQ7Zj1Q7hC9m1NLN9MAsxe9FnastRBfK2XLSwWswhAl07EyZoALh6qooqAeQCTEJ0J0amJQhu1HZflcC0BAozlSU2avDtbbFQc4hED55eIxPG+wBEt93SqFp5Pc4jA5kdJMaF7OiylmR9qJ43LaNIV9Yg5sDaIObBTDj7HVxDG80AAg91VdjzVmmEhzob6yTSHjX3H5R9Atp71A/sXcdCfIIwAfCT62BCO3pkCWXoF6mLyQ0cAuZtAHRjxwIIzB4uixliJNxdRLFrG67+EDVqSpdPcKWJJkjjEClMgLt3bv0cXrKNZ0Dlqc3xJ2qbgPTa0QKLoxvfdvMIJ6fnBQ1lTUGKMX7jhNfFhElRgIbOTkWrDV6mtY0FDHUS+hYzg68zgbqpTxBG4M/YMb6UOYx3goMA5otFUWWW1rcvdl/bnnc5QtTQIoGqkTxVnCCOMX7y9H/rvxwf022Y0EabQA5xWJkCd4stHz/fwHzWgAEbBUEJ8IADfXHrSJXP75lphXGV04wgoc7xAYzRrsoc7kdY/5ovR5vDaN1l7tZBsCB7Q4DD5MZRHpRUSJ8qQEk7Bo5Onjfbp67rcLWaw62DFYxtkjfIp1kd/OjOCh+OeWZKGFQYS8U+HdZ6QpThsBGm48gygxTbscyXWgWLDf0xXhCtksvT0w2cnW1gjD+QJpqw4k93evoujGzTwmBaslFoxFB1k6pMd0BUxhCG/ausz02K6gTRIQIz48WLMzaxE88Rkq+UfjTXGUKQ/zgaNdA0jWnUeLKm+ACjH7PU9bffTn4LTRO8V/N8gzvV8PpJzM5ffkYynCGcielGANYKvhbnGC1R8hRb/IgmmTFNw4zgOx2MbVNwwIARGavzog5WLboj2tPG+pmcDW62O1b989QZmKA+9gK3hDvChDxlwV0qAFlazz6E+vFxeZoGYCUpWwUjQDxgZ3V9DdnxzeFsfSHZZcYf6l3bQdWIuWHVFBJTKGrVwui4PE0DiDLhYCWs/iUxwDc1mVIIooQzWOps31AJQMygLqFpBPIstSpEjGiToLAuATyVTe6w6/oEZyVn/9oHYb8d7Otn4mC93qVwKIQllU91hqhVKPYHQWw+aMzNjEHMq5tC1AQTyJxFK3Lkkud6c4Gbzc49OlitkLxmaGkEac5DNXSmYZI1vC41AXkmZHSIZHPL7KIpGjbdO09wgVMYYHCVCtjxCoYiILvp/VS+yxymNeBJD9p40qoSWUZYQSOPo5IdZBiWPRFa1LCVOPehH+0DJwAhfWFGer5Yd1CqjV4ENX6QW0tOovxmLoXZLYzVg+W5CFVENY0n8LEVMzNUp8u1iutiQJJFzE7HVwjmc6zeBUaXosW04KiSK8BJ1+tUGcnpV9SamSedTp3ddwLzLIkRrplQre9GcEDM9b6M2Nwbpti8zKGQqowBMxHVb1V8KoWQxEbMgz2pSF0lIVJCz3cd9H3l5ylLA9HTkgntZcKgvzi5naZBvHvnkGFolePcYBOpP3p8kpfixDvT5Gc/Yb4JPkBVGrPiauOKkBP/nTTRtvms9b0DS8jM9Kp1jZ5vymBheizORnJX3O0iq2SE76rJuxh7FILdeUbLUuXnhDg4CQqXeOMeOyUj9F9WSS2IXDYBL5BcamkbbZrH9ui4Y+Al6XIu00NxsAmdTkRCE4Yq9FTTd9NLTptTNHZOF132CyUoeEEob4G506qLIHnuPLbeME2xN5aSUYWcPAB4MuSZZYs3kAvoIhzNgSOeXNB1DSn1f19skbTvhBndpHsA2YRtLBhxjrozMtJOzwGo3pXOvE7DuJh0/dlgJSXXf4zV61X9arWmLPlc9Ua9RgtaBgiw4L30nDGLMpQuOKB4ekWaGZ3V2HFSmxQF0mujoreMAy0eFTQ2QHJIVVx24tO1JDu6XUaDqJ4jW3G2ThoVFATK4ECX1yhhsrsJIDRwWIPqTl6kOyZAxKEmgEdQgArk7Nv8GPxGj7z6QCqB+bNyXzPGYejD4XmNb22TK0Kg0RArkwMa2Lr5r2y66RKLturYtHg3Va9vYZF4LqUZXYYIE0uccT5m8MwE4gFeoiYILmnvT4mceW7voXwzL8z44lXj4uzKGwBoWCa/TM3Q1usUEIaJ0ARHMC0bhDrZqRZYO8eygpK9SZ3OEhfzFVD76cLQkk3GWOaseD/ICHWMQ4oyBia0CSbg3tzXVeK21wfU9uViuAbMEQSp5DxUS7rCC/ZM5XG0ulLe6espKu/hMdWJcUoyMK0kljPeErvMP9UaAkUxVNIxV4EIY4WaLx+N07AHBvG9BDgME3sWVQ5lGaNxgg1MKolBjUqyDVtOosgEsTr7V8YV5+fxXMcpuDICzHdibdMwRH/VpBXT8RJa7G5qX2A/dqfs+AGz7eaWK7V0yeGBn4QoP/2ReqxD5StroGImzqjJIQAmRoEkWqm/F0bYm/39hMMYCbWK15jWCMinzrKYc7gbaAHsZbwOLWaUiyc3lg3q9m0OgznuJw0sx+MuVYASw8z5UQVksAZC2YtVW2lVRSjzDK5qkkPSmmE3wIAyO3pNIJgEI9Xa6NVecMdUxWjLFzKzwMth5CluTYBqXbq6pAE5u/QTZ+mxEPT5tm1Hc2HC7rDuBlj4AaXD63+emg/qhkZihKoukJ8vxOWw6o/mSGNz7HGGEYfIWq1ONYqdYN+NDgOTKkJgoDfq6Q50vwA5Y8Mr45Uml1JJnKCkxjlqDHIdJc9tiSomeNbpwEo7Y82k8W0KEvyjvXnQWV+4VO1j/Mk4ppyjSPejHbaIWDHkEupLTpU81g8ZqLQ6Fqnf3zTLf8B1MwCb5tNCd1ZXyHXCYTUfXOUdutpOCeqmSIl4Lt2YGeFzRtcwtzejOCPLvBwwA1XOwm/ee+/OQ7huBrz/7r0/8XI/5pd8ZovMLhiKaHGoBc4oAzlZ6bPuZycGRZJkhORwOWC4H9MBQZgRPPTyGr5goP2LH7//vV/Cq/aqvWqv2sg2Pm+0xk6n/fJLmDfN6eHZ2fb2YkEHPbaHLeCbFHDeYnidXdltjn1vMFi4y1unSwY+C37yrSaEexwUD9iLrRi1Lfn1Cw0D8YI9+5qjyZYXtO6JHrGLe8x9W94J2iI2/4qxv2CguOX48B+GIC84rT7hyHrWUnd2cRGfP3++Pr9//0en/K4p5yP2M0CI/Pzzz1cHB3ePugaO8IJW7IGPePKGUeYKYLbiDbGDALhi/CnEcB8d8Ie/8YAh8orkHgKPgRU/x5/AfXQQeDy/IPXx/ZWWPuM5z79hZmx4QWd8vWWmbHgdG76/lmteljBow+9a9x1t+TEez0zr4yY0uIaeNr2MBdwAnm9DaHYMiE+322bTtuHknXduH++jNUPhhw+f3Wma3b0dhDf++eXTw9XRPey6DpqOh/DOd582fmRrmmXbRD22ZvE8QdCQejCkUrX8VGRWHfvPW+rBT4bo/VCAs54phoQD8t8gVVlj0HOBQXKykEoHoeFr3i9kYUCja5mxgGa9LBjaNyQt6Pnfw38/oYbw9ALjcdPNHjlDWiEcMf6Umm7Ry8I7LXv1TGzTNkJzwmBNwvUthAUSS0Bexf9Yron4BoIkOClVjgmgp58JCjmjSr2SLBX2I255n4jynkN69mpiFzPjLMeo7gXq+50oafrV8Fp77LChllIP86Nv6ZBXesRXP3z48NGGN3b/Hna0u98RLXvZTuJPKqe1QjBP0Olhm3Sv1eX0ZmHBMZSez3NdwCQKI6BqGaQTeVmQrvzBkDAlJN0K9hvSX5TUe89yajS/P50HshtCZVOywER89TvpelcKedA2K/78JNxaLP8G2G8b57csyvbWmvQUM0OIz30mC4xJtjJejvHJj3RY0TR6z/FBxLKPqBukVB+91Cb3opGsSp+8JFYc0Pc7W3xBvXDCpCMCZMkPCyNowhShynW/meHss/btt48ec/9jMYW+3b01a+a343n3GmSiWSu66j3c2cCM7a7Pi5EiiQg0arobgirpQLpCWAiOnE34WBB1qgnYd2D+8CZ4ml7IClWdoC6qQpRRYoHM9HRGgQXWxiysuvXsz2Zh+aLfxWecLT165/t31Qf4AHMK2VMKQ7o2Hi2oX7JIXkOcNx1crNgWZknVGxVRckChEaozwr8aXJwduf6vFQTyVKSkslHvsUJpuizf0aoNycGKXJwJTYPJ4vqIbgkhNnybOnbWJ7Dotm0PJ+s1nHzwwVubfSHypXDAF188OyS6WNB89XqD21szaG+FWXPU93TUNvj2btcv23Y2ZwH/gFe4ZKmtODzcaxDvgYQ/ogPu5xDIGEGTqC2lEEYS+tZMcdJKDn9bucfXT5nuY2bJM6L+OcvgnCPUE9p1Z227PGtfx2f9i8PTr7768+7DDz/cTaHn/7PXlClUi4fyAAAAAElFTkSuQmCC"
          :image-size="64"
        ></es-empty>
      </es-row>
      <div class="footer">
        <div>
          <div></div>
          <es-pagination
            style="text-align: right; margin: 20px 0"
            @current-change="currentChange"
            :current-page.sync="currentPage"
            layout="prev, pager, next, jumper"
            v-show="giftList.length > 0"
            :total="allNumber"
          >
          </es-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { $t } from '@/locales'

import { formatUtc, getShowPrice, getShowUnit, showDataUnit } from '@/util.js'
import { mapState } from 'vuex'
import tsignData from '@tsign/tsigndata-sdk-js'

export default {
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      isOrg: state => state.isOrg,
    }),
  },
  props: {
    search: {
      type: Object,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  data() {
    // giftChannel 1 数量 2时长
    // giftType 1 售前赠送 2 售后赠送
    return {
      ouid: '',
      getShowUnit,
      showDataUnit,
      getShowPrice,
      allNumber: 0,
      giftList: [],
    }
  },
  methods: {
    // 操作转售、授权、历史授权
    empower(item, type, isResale, orderType) {
      tsignData.track('PC_bill_click', { buttonName: 'authorization' })
      this.$router.push({
        path: '/empower',
        query: {
          authOrderId: item.id,
          type,
          isResale,
          orderType,
        },
      })
    },
    downLoad(item) {
      this.$ajax(this.$url.licenseDownload(item.id), {}).then(res => {
        if (res.data.downUrl) {
          window.open(res.data.downUrl)

          return
        }
        const text = res.data.licenseStr
        if (text) {
          const element = document.createElement('a')
          element.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`)
          element.setAttribute('download', `tsign-license-${this.userInfo.gid}-${formatUtc(+new Date(), 'day')}.txt`)
          element.style.display = 'none'
          document.body.appendChild(element)
          element.click()
          document.body.removeChild(element)

          return
        }
        this.$message.error($t('下载请求失败'))
      })
    },
    getDetail(item) {
      const oid = this.userInfo.orgId ? this.userInfo.orgId : this.ouid
      this.$ajax(this.$url.getOrderDetail({ id: item.id, type: 1 }, oid)).then(res => {
        if (res.code === 20502002) {
          this.$message.error(res.message)
          this.$router.push('/Myorder')
        } else {
          let subProductInfo = null
          if (res.data && res.data.subProductInfo) {
            subProductInfo = res.data.subProductInfo.filter(item => item.price !== 0)
          }
          this.$set(item, 'subProductInfo', subProductInfo)
        }
      })
    },
    jumpDetail(item, type) {
      const year = new Date().getFullYear()

      const month = new Date().getMonth() + 1
      if (type === $t('授权记录')) {
        this.$router.push({
          path: '/resellRecord',
          query: {
            orderId: item.showId,
            proId: item.productId,
            isResell: 0,
            gid: item.gid,
          },
        })
      } else {
        this.$router.push({
          path: '/BillDetail',
          query: {
            proId: item.productId,
            year,
            month,
            orderId: item.id,
          },
        })
      }
    },
    currentChange(val) {
      this.currentPage = val
      this.getGiftList()
    },
    searchList() {
      this.currentPage = 1
      this.getGiftList()
    },
    narrow(item) {
      if (item.giftType === 1 && item.saleType === 2) {
        return 10000
      }

      return 1
    },
    getGiftList() {
      const { time, proId, payStatus, status } = this.search
      const data = {
        createTimeStart: time && time.length > 0 ? time[0] : '',
        createTimeEnd: time && time.length > 0 ? time[1] + 24 * 60 * 60 * 1000 : '',
        commodityId: proId,
        payStatus,
        status,
        orderType: 1,
        currentPage: this.currentPage,
        channelGid: this.$route.query.channelGid,
      }
      this.$ajax(this.isOrg ? this.$url.getOrganizeOrderList() : this.$url.getPersonOrderList(), data).then(res => {
        this.giftList = res.data || []
        this.allNumber = res.rowCount || 0
        // eslint-disable-next-line
        this.giftList.map(item => {
          if (item.activeType === 'TYING') {
            item.showType = $t('搭售')
          } else if (item.approvalType === 2) {
            item.showType = $t('售后赔偿')
          } else {
            item.showType = item.giftType === 2 ? $t('增加时长') : item.giftChannel === 1 ? $t('试用') : $t('免费数量')
          }
          item.startToEnd = item.productType === 2 ? '--' : `${formatUtc(item.startTime, 'day')} - ${formatUtc(item.endTime, 'day')}`
          item.showSendNumber =
            item.giftType === 1 && item.isUnLimitNum
              ? $t('无限')
              : item.units === 'G'
              ? showDataUnit(item.totalNum, 'floor', item)
              : getShowPrice(item, 'totalNum', 'G') + getShowUnit(item)
          item.showState = item.webParameter.status

          if (item.status !== 0 && item.status !== 6) {
            if (item.giftType === 1) {
              // 订单数量
              item.sendMargin = item.giftType === 1 && item.isUnLimitNum ? $t('无限') : getShowPrice(item, 'margin', 'G')
            } else {
              // 赠送时长
              if (+new Date() < item.startTime) {
                item.margin = item.totalNum
              } else if (+new Date() > item.endTime) {
                item.margin = 0
              } else {
                item.margin = parseInt((item.endTime - +new Date()) / (60 * 60 * 24 * 1000)) + 1
              }
              item.sendMargin = item.margin
            }
            item.showUserd =
              item.giftType === 1
                ? item.units === 'G'
                  ? showDataUnit(item.used, 'floor', item)
                  : getShowPrice(item, 'used', 'KB', 1) + getShowUnit(item, 'KB', 1, 'used')
                : $t('{slot1}天', { slot1: item.totalNum - item.margin })

            item.showSendMargin =
              item.giftType === 1 && item.isUnLimitNum
                ? $t('无限')
                : item.units === 'G'
                ? showDataUnit(item.margin, 'ceil', item)
                : item.sendMargin + getShowUnit(item, 'G')
          }
        })
      })
    },
  },
  created() {
    this.ouid = localStorage.getItem('ouid')
    this.getGiftList()
  },
}
</script>
<style lang="less" scoped>
.table-card-header {
  height: 80px;
  background: #f7f8fa;
  display: flex;
  box-shadow: 0px 1px 0px 0px #e4e4e4;
  justify-content: space-between;
  padding: 0 30px;
  border: 1px solid #e4e4e4;
  border-bottom: none;
  .table-card-header-name {
    position: relative;
    .table-card-header-checkbox {
      position: absolute;
      left: -20px;
    }
  }
  > div {
    padding-top: 15px;
    display: flex;
    flex-direction: column;
    > div:first-child {
      margin-bottom: 10px;
      color: #232323ff;
      font-weight: 600;
    }
    div:last-child {
      color: #1a1a1aff;
    }
  }
}
.table-title,
.table-main {
  height: 50px;
  line-height: 50px;
  border: 1px solid #e4e4e4ff;
  border-top: none;
  color: #999999;
  padding-left: 30px;
}
.table-main {
  color: #4b4b4bff;
}
.table-card {
  box-shadow: 0px 0px 6px 0px #dce0ef;
  margin: 20px 24px 0;
}
.table-diabled {
  .table-card-header {
    border-bottom: 1px solid #e4e4e4;

    > div {
      > div {
        color: #999999 !important;
      }
    }
  }
  .table {
    .table-main {
      color: #999999 !important;
    }
    background: #f7f8fa !important;
  }
}
.es-icon-circle-check {
  font-size: 15px;
}
.icon-stop {
  background-image: url('../../assets/icons/stop.svg');
  width: 13px;
  height: 13px;
  background-size: cover;
  display: inline-block;
  vertical-align: middle;
}
.readyIcon {
  width: 15px;
  height: 14px;
  background-image: url('../../assets/use/ready.png');
  background-size: cover;
  display: inline-block;
  vertical-align: sub;
}
.ready {
  color: #1890ff !important;
}
.success {
  color: RGBA(5, 199, 5, 1) !important;
}
.unsuccess {
  color: RGBA(179, 179, 179, 1) !important;
}
.stop {
  color: RGBA(250, 173, 20) !important;
}
.footer {
  z-index: 1000;
  background: #fff;
  height: 54px;
  line-height: 54px;
  position: fixed;
  bottom: 0;
  width: 100%;
  min-width: 1100px;
  box-shadow: 0 -1px 2px 0 rgba(0, 0, 0, 0.1);
  > div {
    justify-content: flex-end;
    display: flex;
    padding: 0 24px;
  }
}
/deep/ .es-empty__image{
  width: 64px;
}
</style>
